
// Utility function to decode base64 string
function base64Decode(str) {
    return decodeURIComponent(atob(str).split('').map(function(c) {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
}

// Utility function to validate JWT token
export function isTokenValid(token) {
    if (!token) return false;

    const parts = token.split('.');

    if (parts.length !== 3) {
        // Invalid token structure
        return false;
    }

    try {
        // Decode the payload (second part)
        const payload = JSON.parse(base64Decode(parts[1]));

        // Check if the token is expired
        const currentTime = Date.now() / 1000; 
        if (payload.exp && payload.exp < currentTime) {
            return false;
        }

        return true;
    } catch (e) {
        console.error("Error decoding token", e);
        return false;
    }
}